import { PaletteOptions } from '@mui/material';

export const darkPalette: PaletteOptions = {
  mode: 'dark',

  primary: {
    main: '#9E8DFF',
    dark: '#8173D0',
    light: '#BCB0FF',
    contrastText: '#050911',
  },

  secondary: {
    main: '#3C3B62',
    dark: '#26283E',
    light: '#C7BDFF',
    contrastText: '#FFFFFF',
  },

  error: {
    main: '#BD1601',
    light: '#FF2D12',
  },

  background: {
    default: '#141921',
  },

  grey: {
    600: '#82899A',
  },

  common: {
    black: '#000000',
  },
};
